import { makeStyles } from '@material-ui/core/styles';
import { MOBILE_BREAKPOINT } from '../../config/constants';

export const useStyles = makeStyles(theme => ({
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
    },
    appBar: {
        borderLeft: 0,
        borderTop: 0,
        gridTemplateColumns: '1fr max-content',
        alignItems: 'center',
        padding: '10px 0px',
        backgroundColor: theme.palette.primary.dark,
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.up('lg')]: {
            marginBottom: 15,
        },
    },
    routerLink: {
        color: 'inherit',
        textDecoration: 'none',
    },
    backIcon: {
        fontSize: 10,
    },
    buttonContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    leaveButton: {
        backgroundColor: '#908e99',
        color: 'white',
        borderRadius: 30,
        textTransform: 'none',
        padding: '5px 20px',
    },
    logo: {
        maxWidth: 150,
        maxHeight: 50,
        [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
            maxWidth: 75,
            maxHeight: 25,
        },
    },
    blogLink: {
        color: theme.palette.primary.main,
        alignSelf: 'flex-end',
        marginTop: '14px',
        [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
            fontSize: '12px',
        },
    },
    menuItemsContainer: {
        flex: 1,
    },
    hamburgerIcon: {
        color: 'white',
        width: '36px !important',
        height: '36px !important',
    },
    toolbar: {
        display: 'block',
        width: '100%',
        alignItems: 'center',
    },
    toolbarGrid: {
        width: 'auto',
        minHeight: 75,
        alignItems: 'center',
    },
    mobileToolbar: {
        paddingRight: 0,
        width: '100%',
    },
    leaveStreaming: {
        borderRadius: '50px',
        padding: '0px 16px',
        fontSize: '18px',
        height: '32px',
        border: 0,
        backgroundColor: '#908E99',
        color: '#fff',
        alignSelf: 'center',
        textTransform: 'none',
    },
}));
